(function () {
  'use strict';

  if (window.__morayEmePdpLabelsLoaded) return;
  window.__morayEmePdpLabelsLoaded = true;

  function normalizeColorLabels(root) {
    root.querySelectorAll('.iurop-pdp__option--color .iurop-pdp__option-label').forEach(function (label) {
      label.textContent = 'COLOR';
    });
  }

  function initAll() {
    document.querySelectorAll('[data-pdp]').forEach(normalizeColorLabels);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', initAll);
})();
